import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Box, Typography } from '@kareo/design-system';
import ErrorImage from '../../assets/img/loading-error.png';
import { StyledImage } from '../../utils/styledPsychNote';
import { GENERIC_ERROR_HEADER, GENERIC_ERROR_INSTRUCTIONS, } from '../../constants';
var GenericLoadingErrorPage = function () {
    return (React.createElement(Box, { mt: 2, minHeight: "25vh" },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, sm: 7 },
                React.createElement(Typography, { variant: "h3" }, GENERIC_ERROR_HEADER),
                React.createElement(Typography, null, GENERIC_ERROR_INSTRUCTIONS)),
            React.createElement(Grid, { item: true, sm: 5 },
                React.createElement(Box, { display: "flex", justifyContent: "center" },
                    React.createElement(StyledImage, { src: ErrorImage, alt: "loading error" }))))));
};
export default GenericLoadingErrorPage;
